import type {
  Service,
  Warranty
} from '@/modules/product/domain/ProductDetails';
import type { VariantPriceDto } from '@/modules/shared/types/PriceDto';

import type { BreadcrumbDto } from './BreadcrumbsDto';
import type { WarrantiesCustomObjectDto } from './WarrantiesCustomObjectDto';

export type PropertyValue =
  | string
  | unknown[]
  | boolean
  | WarrantiesCustomObjectDto
  | { key: string; label: string };

interface Property {
  label: string;
  name: string;
  value: PropertyValue;
}

export interface DataSheetDto {
  title: string;
  properties: Property[];
}

interface ImageDto {
  url: string;
  label?: string;
  dimensions: {
    w: number;
    h: number;
  };
}

export interface VariantDTO {
  id: number;
  key?: string;
  sku: string;
  prices: VariantPriceDto;
  attributes?: {
    name: string;
    value: string;
  }[];
  sellersSku?: string;
  sellers?: string[]; // Cart
  warranties?: Warranty[];
  services?: Service[];
  dataSheet?: DataSheetDto[];
  images: ImageDto[];
  isPreSale: boolean;
  collections?: string[];
}

export enum Collections {
  TAG_BENEFICIOS_CRUZADOS_COLABORADORES = 'tag-beneficios-cruzados-colaboradores'
}

export interface HttpProductDetailsDto {
  id: string;
  name: {
    'es-CL': string;
  };
  averageRating: number;
  countRating: number;
  brand: string;
  productType: {
    id: string;
    key: string;
  };
  sellers: string[];
  description: {
    'es-CL': string;
  };
  categories: {
    id: string;
  }[];
  slug: {
    'es-CL': string;
  };
  isMarketplace: boolean;
  primaryCategoryBreadcrumb: BreadcrumbDto[];
  masterVariant: VariantDTO;
  variants?: VariantDTO[];
}

export interface HttpProductListResponseDto {
  statusCode: number;
  count: number;
  limit: number;
  message?: string;
  offset: number;
  page?: number;
  total: number;
  products: HttpProductDetailsDto[];
}

export interface HttpProductDetailsListDto {
  count: number;
  limit: number;
  offset: number;
  total: number;
  results: HttpProductDetailsDto[];
}
